module.exports = __webpack_public_path__ + "static/media/main-baloon-share.a014a75d.png";